const pagesLaborCoreOperationPackagesEn = {
  laborCore: "Labor Core",
  startNew: "Start new",
  tabs: {
    operationPackages: "Operation packages",
    archive: "Archive",
    config: "Config",
  },
  patternEmptyState: {
    title: "No operation package pattern",
    description:
      "No operation package pattern found. Please register from the Add pattern button above.",
  },
  status: {
    todo: "Not Started",
    completed: "Completed",
    attachment: "Attachment",
    approval: "Approval",
    approvalRequired: "Approval Required",
    notRequired: "Not Required",
  },
  displayDataAggregate: "View: Data summary",
  sideTab: {
    demoItems: {
      employmentTypeChange: "Employment type change application",
      contractRenewal: "Labor contract renewal",
      eGovernment: "e-Gov applications",
      yearEndAdjustment: "Year-end tax adjustment",
      myNumber: "My Number collection procedure",
      marriage: "Marriage procedures",
      divorce: "Divorce procedures",
      commuteRouteChange: "Commute route update",
      transfer: "Transfer procedures for office transfers",
      contactChange: "Contact info update",
      condolence: "Celebratory/Condolatory occasion procedures",
      bankAccountChange: "Bank account update",
      companyHousing: "Company housing application",
      license: "License and qualification procedures",
      elderlyEmployment: "Elderly employment continuation benefit application",
      healthManagement: "Health management",
      overtimeMeasures: "Overwork measures",
      remoteWork: "Remote work management",
      certificate: "Certificate reque",
    },
    underDevelopment: "This operation package is currently under development.",
  },
  taskEmptyState: {
    title: "No Operation task",
    description: "Initiate from the start new button above.",
  },
  assignTaskToPerson: {
    selectPackage: "Select operation package",
    selectPackageDescription: "Select the operation package you want to start",
    selectPackagePattern: "Select operation package pattern",
    selectPackagePatternDescription:
      "Select the operation package pattern you want to start",
    selectPerson: "Select target",
    selectPersonDescription: "Select the target to assign",
    startOperationTask: "Start operation package",
    startOperationTaskDescription:
      "Start the operation task by selecting the operation package and pattern, and then assigning the target.",
    selectedOperationPackage: "Selected operation package",
    selectedOperationPattern: "Selected operation package pattern",
    selectPersonPlaceholder: "Select target",
    selectedPerson: "Selected target",
    anchorDate: "Anchor date",
    assignSuccess: "Operation package started successfully",
    assignSuccessMessage: "{{count}} people assigned",
    validationErrors: {
      pastDateWithNewPerson: "Choose the future dates when adding new people",
      noPersonSelected: "Please select at least one person to assign",
    },
  },
};

export default pagesLaborCoreOperationPackagesEn;
